module.exports = __webpack_public_path__ + "static/img/register.01d10983.gif";